import React from 'react';
import { graphql } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import { Link } from 'gatsby';
const ModularHeaderBodyImageColumn = ({ data }) => {
  const {
    header,
    body,
    imageButtonContent,
    backgroundColor,
    idContent,
    noTopPadding,
    noBottomPadding,
  } = data;
  return (
    <div
      className={`${backgroundColor} modular-header-body-image-column-container`}
      id={`${idContent}`}
    >
      <div
        className={`modular-global-width modular-text-center  ${
          noBottomPadding && 'modular-padding-large-no-bottom'
        } ${noTopPadding && 'modular-padding-large-no-top'} ${
          !noBottomPadding && !noBottomPadding && 'modular-padding-large'
        }`}
      >
        <div className="modular-heading-third modular-heading-secondary">
          <LitStructuredText data={header} basic />
        </div>
        <div className="modular-p">
          <LitStructuredText data={body} basic />
        </div>
        <div className="image-button-container">
          {imageButtonContent.map(
            ({ buttonPath, buttonText, image, linkPath }, index) => {
              return (
                <div className="image-button-inner" key={index}>
                  <div className="image">
                    <LitImage image={image} />
                  </div>
                  {linkPath ? (
                    <a href={linkPath.url} target="_blank">
                      {buttonText}
                    </a>
                  ) : (
                    <Link to={buttonPath}>{buttonText}</Link>
                  )}
                </div>
              );
            },
          )}
        </div>
      </div>
    </div>
  );
};

export default ModularHeaderBodyImageColumn;
export const fragment = graphql`
  fragment ModularHeaderBodyImageColumn on DatoCmsHeaderBodyImageColumn {
    internal {
      type
    }
    noBottomPadding
    noTopPadding

    backgroundColor
    idContent
    header {
      value
    }
    body {
      value
    }
    imageButtonContent {
      buttonPath
      buttonText
      linkPath {
        url
      }
      image {
        gatsbyImageData
      }
    }
  }
`;
